module.exports = __webpack_public_path__ + "static/media/Orinocco23.82a7042e.jpg";